import { render, staticRenderFns } from "./AddPackingNoteModel.vue?vue&type=template&id=cf031488&"
import script from "./AddPackingNoteModel.vue?vue&type=script&lang=js&"
export * from "./AddPackingNoteModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports